import { Col, Container, Row } from 'react-bootstrap'
import { useAdmin } from '../../contexts/AdminContext'
import { useUsers } from '../../contexts/UsersContext'

import './supplier.css'
import { useEffect, useState } from 'react'

const Summary = () => {
  const { orders, quotes, messages } = useAdmin()
  const { loggedOnUser } = useUsers()
  const [myQuotes, setMyQuotes] = useState([])
  const [myMessages, setMyMessages] = useState([])
  const [myOrders, setMyOrders] = useState([])
  const [potentialOrders, setPotentialOrders] = useState([])
  const [rcvdMessages, setRcvdMessages] = useState([])
  const { setClickedLink } = useAdmin()

  useEffect(() => {
    if (loggedOnUser) {
      if (loggedOnUser.role === 'business') {
        setMyQuotes(
          quotes && quotes.filter((quote) => quote.from === loggedOnUser.email)
        )
        setMyMessages(
          messages &&
            messages.filter((message) => message.from === loggedOnUser.email)
        )
        setRcvdMessages(
          messages &&
            messages.filter((message) => message.to === loggedOnUser.email)
        )
        setMyOrders(
          orders &&
            orders.filter(
              (order) =>
                order.status === 'Quote Accepted' &&
                quotes &&
                quotes
                  .filter((quote) => quote.supplier === loggedOnUser.email)
                  .map((quote) => quote.orderId)
                  .includes(order.id)
            )
        )
        setPotentialOrders(
          orders && orders.filter((order) => order.status === 'New')
        )
      }
    }
  }, [loggedOnUser, quotes, orders, messages])

  return (
    <>
      <Container>
        <Row className='member-statistical'>
          <Col sm={3}>
            <div className='item blue'>
              <h3>Potential Work Orders</h3>
              <span
                className='number my_link'
                onClick={() => setClickedLink('Potential Orders')}
              >
                {potentialOrders && potentialOrders.length}
              </span>{' '}
              <span className='line'></span>
            </div>
          </Col>
          <Col sm={3}>
            <div className='item green'>
              <h3>Messages</h3>
              <span
                className='number my_link'
                onClick={() => setClickedLink('Messages')}
              >
                Sent: {myMessages ? myMessages.length : 0} <br /> Rcvd:{' '}
                {rcvdMessages ? rcvdMessages.length : 0}
              </span>{' '}
              {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>{' '}
          <Col sm={3}>
            <div className='item yellow'>
              <h3>Quotes Sent</h3>
              <span
                className='number my_link'
                onClick={() => setClickedLink('Quotes Sent')}
              >
                {myQuotes ? myQuotes.length : 0}{' '}
              </span>{' '}
              {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>{' '}
          <Col sm={3}>
            <div className='item purple'>
              <h3>Work in Progress</h3>
              <span
                className='number my_link'
                onClick={() => setClickedLink('WIP')}
              >
                {myOrders ? myOrders.length : 0}{' '}
              </span>{' '}
              {/* Get from DB */}
              <span className='line'></span>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Summary
